import { useEffect, useRef, type ReactNode, type RefObject } from 'react';
import {
  clearMobilePreviewLayoutCssVars,
  syncMobilePreviewLayoutCssVars,
} from '../apps/mynazca/mynazcaLayoutUtils';

type MyNazcaMobileStepLayoutProps = {
  lang: 'ja' | 'en';
  stepBarRef: RefObject<HTMLElement | null>;
  preview: ReactNode;
  children: ReactNode;
};

export function MyNazcaMobileStepLayout({
  lang,
  stepBarRef,
  preview,
  children,
}: MyNazcaMobileStepLayoutProps) {
  const mobileStepRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const sync = () => syncMobilePreviewLayoutCssVars(stepBarRef.current, mobileStepRef.current);
    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    return () => {
      window.removeEventListener('scroll', sync);
      window.removeEventListener('resize', sync);
      clearMobilePreviewLayoutCssVars();
    };
  }, [stepBarRef]);

  return (
    <div ref={mobileStepRef} className="mynazca-app__mobile-step">
      <div className="mynazca-app__mobile-preview-dock" aria-label={lang === 'ja' ? 'プレビュー' : 'Preview'}>
        {preview}
      </div>
      <div className="mynazca-app__mobile-step-body mynazca-app__panel">{children}</div>
    </div>
  );
}
